import React, { useEffect, useState } from "react";
import {
  Box,
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import TutorialPreview from "./TutorialPreview";

export default function TutorialCadastro({
  open,
  onClose,
  titulo,
  subtitulo = "",
  etapas = [],
  etapasExecucao = [],
}) {
  const [etapaAtual, setEtapaAtual] = useState(0);
  const [tipoTutorial, setTipoTutorial] = useState("sistema");

  useEffect(() => {
    if (open) {
      setEtapaAtual(0);
      setTipoTutorial("sistema");
    }
  }, [open]);

  const etapasAtuais = tipoTutorial === "execucao" ? etapasExecucao : etapas;
  const etapa = etapasAtuais[etapaAtual];
  const ultimaEtapa = etapaAtual === etapasAtuais.length - 1;
  const progresso = etapasAtuais.length ? ((etapaAtual + 1) / etapasAtuais.length) * 100 : 0;

  if (!etapa) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ pr: 7 }}>
        {titulo}
        {subtitulo && (
          <Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 0.5 }}>
            Referências: {subtitulo}
          </Typography>
        )}
        <IconButton
          aria-label="Fechar tutorial"
          onClick={onClose}
          sx={{ position: "absolute", right: 12, top: 12 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {etapasExecucao.length > 0 && (
        <Tabs
          value={tipoTutorial}
          onChange={(_, valor) => {
            setTipoTutorial(valor);
            setEtapaAtual(0);
          }}
          variant="fullWidth"
        >
          <Tab value="sistema" label="Como usar o sistema" />
          <Tab value="execucao" label="Como executar o ensaio" />
        </Tabs>
      )}

      <LinearProgress variant="determinate" value={progresso} />

      <DialogContent dividers sx={{ p: { xs: 2, md: 3 } }}>
        {tipoTutorial === "execucao" && (
          <Alert severity="info" sx={{ mb: 2 }}>
            Material de apoio ao treinamento. A execução deve seguir a edição vigente da norma, o procedimento interno aprovado e os equipamentos calibrados.
          </Alert>
        )}
        <Typography variant="overline" color="primary.main" fontWeight={700}>
          Etapa {etapaAtual + 1} de {etapasAtuais.length}
        </Typography>
        <Typography variant="h5" component="h2" fontWeight={700} gutterBottom>
          {etapa.titulo}
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          {etapa.descricao}
        </Typography>

        {etapa.preview && <TutorialPreview tipo={etapa.preview} />}

        {!etapa.preview && etapa.imagem && (
          <Box
            component="img"
            src={etapa.imagem}
            alt={etapa.alt || etapa.titulo}
            sx={{
              display: "block",
              width: "100%",
              maxHeight: { xs: 260, md: 430 },
              objectFit: "contain",
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              backgroundColor: "#f8fafc",
            }}
          />
        )}

        {etapa.dicas?.length > 0 && (
          <Box component="ul" sx={{ mt: 2, mb: 0, pl: 3 }}>
            {etapa.dicas.map((dica) => (
              <Typography component="li" key={dica} sx={{ mb: 0.75 }}>
                {dica}
              </Typography>
            ))}
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ justifyContent: "space-between", px: 3, py: 2 }}>
        <Button onClick={onClose}>Fechar</Button>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            startIcon={<NavigateBeforeIcon />}
            disabled={etapaAtual === 0}
            onClick={() => setEtapaAtual((anterior) => anterior - 1)}
          >
            Anterior
          </Button>
          <Button
            variant="contained"
            endIcon={ultimaEtapa ? null : <NavigateNextIcon />}
            onClick={() => {
              if (ultimaEtapa) onClose();
              else setEtapaAtual((anterior) => anterior + 1);
            }}
          >
            {ultimaEtapa ? "Concluir" : "Próximo"}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
